import React, { ChangeEvent } from "react";
import AIButton from "shared/components/AIButton";
import { StyledInlinePromptContainer, StyledInlinePromptInput } from "./styled";

export type InlinePromptInputProps = {
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  onGenerate: () => void;
  disabled?: boolean;
  isLoading?: boolean;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
};

const InlinePromptInput: React.FC<InlinePromptInputProps> = ({
  value,
  onChange,
  placeholder = "",
  onGenerate,
  disabled = false,
  isLoading = false,
  onKeyDown,
}) => (
  <StyledInlinePromptContainer>
    <StyledInlinePromptInput
      type="text"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      onKeyDown={onKeyDown}
      disabled={disabled || isLoading}
    />
    <AIButton
      title="Generate"
      onClick={onGenerate}
      disabled={disabled || isLoading}
      loading={isLoading}
    />
  </StyledInlinePromptContainer>
);

export default InlinePromptInput;
